<template>
  <b-card>
    <div slot="header">
      <i :class="options.icon || ''" v-if="options.icon"></i>

      <strong>
        {{ options.name || '' }}
      </strong>

      <small>
        {{ options.caption || '' }}
      </small>

      <div class="card-actions text-right">
        <div class="align-left">
          <a :href="options.link.href || '#!'"
            :target="options.link.target || '_self'">

            <slot name="action"></slot>
          </a>
        </div>
      </div>
    </div>

    <b-list-group>
      <slot name="card"></slot>
    </b-list-group>

    <div slot="footer">
      <slot name="footer" v-if="options.link">
        <a :href="options.link.href || '#!'"
          :target="options.link.target || '_self'"
          class="see-all">

          <small class="btn">
            Visualizar todos
            <i class="fa fa-long-arrow-right"></i>
          </small>
        </a>
      </slot>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'list-groups',

  props: {
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">

  .see-all {

    text-align: center;
    display: inline-block;
    float: none;
    width: 100%;

    small {
      text-transform: uppercase;
      padding: 0;
      text-align: center;
      text-decoration: none !important;
    }

    &:hover {
      small {
        color: #01a1db;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/core/ListGroups.vue